module.exports = __webpack_public_path__ + "img/13n.7b1ce954.svg";